<template>
    <b-row class="px-2 no-gutters">
        <b-col class="d-flex">
            <div class="my-auto" style="font-size: 1rem; font-weight: 600;">{{ $t('ParentMeters') }}</div>
            <b-button class="btn-circle my-auto bg-white border-gray text-black mx-2" :style="!showArrow ? 'opacity: 0; pointer-events: none' : parentMeterList[0]?.key == 0 ? 'opacity: .65; pointer-events: none;' : ''" style="z-index: 2;" @click="updateParentMeterSections(-1)">
                <b-icon icon="chevron-left" scale="0.95"/>
            </b-button>
            <div v-for="(parent, index) in parentMeterList" :key="index" style="width: 13.5rem;" class="d-flex flex-column justify-content-center mx-1">
                <div class="bg-white border border-gray px-0 py-2 d-flex rounded" style="z-index: 2;"
                    role="button" @click="showChangeCurrentMeter(parent.value)">
                    <div class="d-flex align-items-center h-100 w-100">
                        <b-img class="mx-1" style="height: 1.15rem; width: 1rem;" :src="AbsoluteLink(parent.value.Icon)" />
                        <div class="w-100 text-truncate mx-1 d-flex">
                            <span class="font-weight-bold text-truncate text-black" style="font-size: .75rem" v-b-tooltip.hover :title="parent.value.Name">{{ parent.value.Name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <b-button class="btn-circle my-auto bg-white border-gray text-black position-absolute" :style="!showArrow ? 'opacity: 0; pointer-events: none' : parentMeterList[parentMeterList.length - 1]?.key == fieldCount() ? 'opacity: .65; pointer-events: none;' : ''" style="z-index: 2; right: .5rem; top: 50%; transform: translateY(-50%);" @click="updateParentMeterSections(1)">
                <b-icon icon="chevron-right" scale="0.95"/>
            </b-button>
        </b-col>
        <b-modal id="modal" size="md" v-model="showChangeMeter.key" hide-header centered no-close-on-backdrop no-close-on-esc>
            <template>
                <div class="h-100 w-100">
                    <h6 class="modal-title text-center w-100 font-weight-bold">{{ $t('AccessMeter', {meterName: showChangeMeter.value?.Name} )}} </h6>
                </div>
            </template>
             <template #modal-footer>
                <b-button @click="changeCurrentMeter(false)" :variant="'outline-' + Variant" pill>{{$t('Cancel')}}</b-button>
				<b-button @click="changeCurrentMeter(true)" :variant="Variant" pill>{{$t('Submit')}}</b-button>
            </template>
        </b-modal>
    </b-row>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { Prop, Vue, Component, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TreeNode from '@/types/TreeNode';
import { MAIN_FILTER_TREE } from "@/App.settings";
import locales from "../locales/Allocation.json";
import { LinkUtils } from '@/components/commons/Utils';
import 'vue-cute-timeline/dist/index.css';
import FormDraft from "@/types/fields/FormDraft";
import Section from '@/types/fields/Section';
import Dictionary from '@/types/Dictionary';
import IField from '@/interfaces/IField';
import FieldTypeEnum from '@/enums/fields/FieldTypeEnum';
import Period from '@/types/Period';
import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
import { BaseObjectForm } from '../BaseObjectForm';
import GraphNode from '@/types/fields/GraphNode';

@Component({
    components: {
        'hsc-menu-style-custom': HscMenuStyleCustom("secondary"),
    },
    i18n: { messages: locales }
})
export default class AllocationHeader extends mixins(LinkUtils, BaseObjectForm<FormDraft<Section<Period, Dictionary<IField[]>>>>) 
{
    @Prop()
    public Sections!: Section<Period, Dictionary<IField[]>>[];

    @Prop()
    public IndexWidth!: number;

    @Getter('ObjectStore/GetUpdatedForms')
    private updatedForms!: string[];

    private parentMeterList: { key: number, value: TreeNode }[] = [];
    private showChangeMeter: { key: boolean, value: TreeNode } = {key: false, value: null};
    private showArrow: boolean = false;
   
    /**
     * Copie de Allocation 
     */
    private showChangeCurrentMeter(node: TreeNode)
    {
        if(this.updatedForms.filter(u => u == "Allocation").length == 0)
        {
            this.showChangeMeter = {key: false, value: node};
            this.changeCurrentMeter(true);
        }
        else
            this.showChangeMeter = {key: true, value: node};
    }

    private changeCurrentMeter(valid: boolean) : void
    {
        if(valid)
            this.$store.dispatch(MAIN_FILTER_TREE +  "/SelectNode", { node: this.showChangeMeter.value, openNode: true, scrollIntoView: true });

        this.showChangeMeter = {key: false, value: null};
    }

    /**
     * Genere la liste des sections parents pour l'affichage
     * @param list 
     * @param currentParentMeter 
     * @param index
     * @returns { void }
     */
    @Watch('Sections', { deep: true })
    @Watch('IndexWidth')
    private updateParentMeterSections(index: number) : void 
    {
        let parentMeter: {key: number, value: TreeNode}[] = [];
        let _sectionStart: number = 0;
        this.showArrow = false;

        if(this.Sections.length > 0)
        {
            let TreeNode: TreeNode[] = this.Sections[0].Fields[nodesField].map(u => 
            {
                return this.$store.getters[MAIN_FILTER_TREE + "/Node"]((u as GraphNode).Id) as TreeNode;
            });

            if(TreeNode.length > this.IndexWidth && index != undefined && this.parentMeterList.length > 0)
            {
                this.showArrow = true;
                let minIndex: number = this.parentMeterList.map(y => y.key).reduce((a, b) => Math.min(a, b));
                let maxIndex: number = this.parentMeterList.map(y => y.key).reduce((a, b) => Math.max(a, b));

                _sectionStart = minIndex;

                if(minIndex + index >= 0 && maxIndex + index < TreeNode.length)
                    _sectionStart += index;
            }

            for(let i = _sectionStart; i < _sectionStart + this.IndexWidth; i++)
            {
                if(TreeNode[i])
                    parentMeter.push( { key: i, value: TreeNode[i] } );
            }
        }

        this.parentMeterList = parentMeter;
    }

    private fieldCount() : number
    {
        return this.Sections?.map(u => u.Fields[nodesField]).flat().length - 1;
    }
}

/** Clé du dictionnaire des Fields contenant les Nodes */
const nodesField: string = FieldTypeEnum[FieldTypeEnum.Node].toString();

</script>

<style>
</style>